import ChevronLeftSvg from "@/src/assets/icons/icon-chevron-left-black.svg";
import { Button } from "@/src/components/atom/Button";
import Editor from "@/src/components/atom/Editor";
import Icon from "@/src/components/atom/Icon";
import Typo from "@/src/components/atom/Typo";
import BottomFixedContainer from "@/src/components/molecule/BottomFixedContainer";
import SectionCardWithoutHeader from "@/src/components/molecule/SectionCardWithoutHeader";
import ImporterMainLayout from "@/src/components/template/Layout/importer/ImporterMainLayout";
import DATE_FORMAT_STRINGS from "@/src/constant/dateFormat";
import useAlert from "@/src/hooks/useAlert";
import { useCompanyLocalDate } from "@/src/hooks/useCompanyLocalDate";
import { useGetSessionQuery } from "@/src/store/apis/auth";
import { useLazyGetNoticeQuery } from "@/src/store/apis/notice";
import colorSet from "@/src/styles/color";
import typo from "@/src/styles/typography";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { styled } from "styled-components";

const ImporterNoticeDetailPage = () => {
  const { t, i18n } = useTranslation();
  const alert = useAlert();
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();

  useGetSessionQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [getNotice, noticeResult] = useLazyGetNoticeQuery();

  const locationDate = useCompanyLocalDate({
    date: noticeResult?.currentData?.createdAt || "",
    format: DATE_FORMAT_STRINGS.YYYY_MM_DD,
  });

  useEffect(() => {
    (async () => {
      try {
        await getNotice({ id: Number(id) }).unwrap();
      } catch (e: any) {
        const message = Array.isArray(e.data.message)
          ? e.data.message[0]
          : e.data.message;
        alert.showAlert({ message, type: "error" });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ImporterMainLayout
      breadcrumb={[t("sideNav:notice")]}
      pageTitle={t("sideNav:notice")}
    >
      <Article>
        <StyledSectionCardWithoutHeader>
          <Wrapper>
            <NoticeTitleContainer>
              <NoticeTitle>
                {i18n.language === "ko"
                  ? noticeResult.currentData?.titleKr
                  : noticeResult.currentData?.titleEn}
              </NoticeTitle>
              <Typo typoType="b7r" color="gray6" className="flex-shrink-0">
                {locationDate}
              </Typo>
            </NoticeTitleContainer>
            <Editor
              isReadOnly
              value={
                i18n.language === "ko"
                  ? noticeResult.currentData?.bodyKr || "-"
                  : noticeResult.currentData?.bodyEn || "-"
              }
            />
          </Wrapper>
        </StyledSectionCardWithoutHeader>

        <BottomFixedContainer>
          <FooterButtonSection>
            <Button
              buttonGrade="tertiary"
              buttonColor="black"
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
              onClick={() => navigate(-1)}
            >
              <Icon iconSrc={ChevronLeftSvg} iconSize={16} />
              {t("common:backToPrevious")}
            </Button>
          </FooterButtonSection>
        </BottomFixedContainer>
      </Article>
    </ImporterMainLayout>
  );
};

export default ImporterNoticeDetailPage;

const Article = styled.article`
  margin-bottom: 72px;
`;

const NoticeTitleContainer = styled.h2`
  padding: 16px;
  ${typo.h4}
  border-bottom: 1px solid ${colorSet.gray8};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .flex-shrink-0 {
    flex-shrink: 0;
  }
`;

const NoticeTitle = styled.p`
  word-break: break-all;
`;

const FooterButtonSection = styled.section`
  display: flex;
  justify-content: space-between;
`;

const StyledSectionCardWithoutHeader = styled(SectionCardWithoutHeader)`
  min-height: 860px;
`;

const Wrapper = styled.div`
  padding: 16px;
`;
